<template>
    <div>
        <btn icon @click="open()" style="font-size: 15px;width: 100%;height: 30px;line-height: 20px;margin: 0" :class="{border:show}">
            <i class="fal fa-plus"></i> {{$t('Add label')}}
        </btn>
        <ul class="dropdown" v-if="show">
            <li v-for="item in items" :key="item.type" @mousedown.stop="$emit('change', item); close();">
                <i class="fal" :class="item.icon" v-if="item.icon"></i> {{item.label}}
            </li>
        </ul>
    </div>
</template>

<script>
import Btn from "@/modules/buttons/btn";
import events from "@/events/events";
export default {
    name: "btn-dropdown",
    components: {Btn},
    props:{
        items:Array,
    },
    data(){
        return {
            show:false
        }
    },
    methods:{
        open(){
            
            if(this.show){
                return this.close()
            }
            
            this.show = true
            setTimeout(() => {
                events.$on("body:click:mouse:up",this.close)
            },10)
        },
        close(){
            this.show = false;
            events.$off("body:click:mouse:up",this.release)
        }
    },
}
</script>